const $inject = ['$filter', 'settingsService', 'ENUMS', 'moment'];

const dateTimeService = function ($filter, settingsService, ENUMS, moment) {
  const FILE_DATE_FORMAT_SHORT = $filter('translate')('dates.DateFormat');
  const FILE_DATE_FORMAT_MEDIUM = $filter('translate')('dates.DateFormatMedium');
  const FILE_DATE_FORMAT_LONG = $filter('translate')('dates.DateFormatLong');
  const FILE_TIME_FORMAT_LONG = $filter('translate')('dates.TimeFormatLong');
  const FILE_DATE_TIME_FORMAT_LONG = $filter('translate')('dates.DateTimeFormatLong');

  const service = {
    layoverInMinutes: layoverInMinutes,
    getFormat: getFormat,
    getMinutesFromTime: getMinutesFromTime,
    getDateTimeFromDateAndTime: getDateTimeFromDateAndTime,
  };

  function getFormat(enumValue) {
    const dateTimeConfiguration = settingsService.settings.DateTimeConfiguration;
    switch (enumValue) {
      case ENUMS.dateTimeFormats.DATE_SHORT:
        return dateTimeConfiguration.DateFormatShort ? dateTimeConfiguration.DateFormatShort : FILE_DATE_FORMAT_SHORT;

      case ENUMS.dateTimeFormats.DATE_MEDIUM:
        return dateTimeConfiguration.DateFormatMedium ? dateTimeConfiguration.DateFormatMedium : FILE_DATE_FORMAT_MEDIUM;

      case ENUMS.dateTimeFormats.DATE_LONG:
        return dateTimeConfiguration.DateFormatLong ? dateTimeConfiguration.DateFormatLong : FILE_DATE_FORMAT_LONG;

      case ENUMS.dateTimeFormats.TIME_LONG:
        return dateTimeConfiguration.TimeFormatLong ? dateTimeConfiguration.TimeFormatLong : FILE_TIME_FORMAT_LONG;

      case ENUMS.dateTimeFormats.DATE_TIME_LONG:
        return dateTimeConfiguration.DateTimeFormat ? dateTimeConfiguration.DateTimeFormat : FILE_DATE_TIME_FORMAT_LONG;

      default:
        throw new Error('Invalid dateTime format required in dateTimeService.getFormat');
    }
  }

  function getMinutesFromTime(time) {
    const timeParts = time.split(':');
    return parseInt(timeParts[0], 10) * 60 + parseInt(timeParts[1], 10);
  }

  function layoverInMinutes(durationStr) {
    if (!durationStr) return 0;
    const hours = durationStr.includes('h') ? parseInt(durationStr.split('h')[0], 10) : 0;
    const minutes = durationStr.includes('m') ? parseInt(durationStr.split('m')[0], 10) : 0;
    return hours * 60 + minutes;
  }

  function getDateTimeFromDateAndTime(pickupDate, timeValue) {
    const DATE_FORMAT = service.getFormat(ENUMS.dateTimeFormats.DATE_MEDIUM);
    const TIME_FORMAT = service.getFormat(ENUMS.dateTimeFormats.TIME_LONG);

    let pickUpDateTime = moment(pickupDate, DATE_FORMAT + TIME_FORMAT).utc();
    let time = moment(timeValue);

    pickUpDateTime.millisecond(time.millisecond());
    pickUpDateTime.second(time.second());
    pickUpDateTime.minute(time.minute());
    pickUpDateTime.hour(time.hour());
    return pickUpDateTime;
  }

  return service;
};

dateTimeService.$inject = $inject;
export default dateTimeService;



// WEBPACK FOOTER //
// ./src/services/dateTimeService.js